export default {"src":"/_next/static/media/CentralizeManagement.f493848b.svg","height":303,"width":457};